import { TaskModel } from '@bryntum/gantt';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ProjectPhase } from 'api/project';
import { Field, FieldValue, FieldValueType, StatusGroup } from 'api/tasks';
import { ReactComponent as FormTemplateIconSvg } from 'assets/svgs/form-instance-icon.svg';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { useProjectPhaseStatusField, useStatusField } from 'data/fields/hooks';
import { Task } from 'data/tasks';
import { GanttType } from './helpers';

const TaskDetails = styled.div`
  display: flex;
  align-items: center;
`;

const TaskName = styled.span`
  margin-left: var(--spacing-03);
  margin-bottom: 1px;
  display: flex;
  gap: var(--spacing-02);
  align-items: center;
`;

export const TaskDetail: FC<{ record: TaskModel; value: string }> = ({
  record,
  value,
}) => {
  const taskStatusField = useStatusField();
  const projectPhaseStatusField = useProjectPhaseStatusField();
  const getStatusFieldDetails = (): {
    statusField: Field;
    statusFieldValue: FieldValue<FieldValueType> | undefined;
  } => {
    const recordData: Task | ProjectPhase = record.get('data');

    if (record.getData('type') === GanttType.ProjectPhaseBar) {
      return {
        statusField: projectPhaseStatusField,
        statusFieldValue: recordData.fields?.find(
          (f) => f.fieldId === projectPhaseStatusField?.fieldId,
        ),
      };
    }

    return {
      statusField: taskStatusField,
      statusFieldValue: recordData.fields?.find(
        (f) => f.fieldId === taskStatusField?.fieldId,
      ),
    };
  };

  const title =
    record.getData('type') === GanttType.ProjectPhaseBar ? `${value}:` : value;

  const recordData: Task | ProjectPhase = record.get('data');

  const { formInstanceId } = recordData as Task;
  const { statusField, statusFieldValue } = getStatusFieldDetails();
  const selectedStatusMeta = statusField?.metaData?.options?.find(
    (_option) => _option.value === statusFieldValue?.fieldValue,
  );

  return (
    // TODO:: @abhilashlr Picker has an issue with click. Figure out.
    <TaskDetails>
      {/* <StatusPicker
            dropdownHeader=""
            onChange={(val) => console.log(val)}
            options={statusField.metaData?.options}
            value={statusFieldValue.metaFieldValue.value}
          >
            <StatusPicker.Trigger
              selectedStatus={{
                color: statusFieldValue.metaFieldValue.color,
                group: statusFieldValue.metaFieldValue
                  .group as StatusGroup,
                label: statusFieldValue.metaFieldValue.label,
                value: statusFieldValue.metaFieldValue.value,
              }}
              progress={0}
            />
          </StatusPicker> */}
      {statusField?.metaData &&
      statusFieldValue?.metaFieldValue &&
      selectedStatusMeta ? (
        <StatusIndicator
          progress={(recordData as Task).progress || 0}
          status={{
            color: selectedStatusMeta.color,
            group: selectedStatusMeta.group as StatusGroup,
            label: selectedStatusMeta.label,
          }}
          type={(recordData as Task).type}
        />
      ) : null}
      <TaskName title={title}>
        {formInstanceId ? <FormTemplateIconSvg /> : null}
        {title}
      </TaskName>
    </TaskDetails>
  );
};
